export const variables = {
  connectHash: "c2l0ZWRydXBhbEBtYXN0ZXIuY29tfCUjUzF0M0BEcnVwYWwh",
};
export const ufSelect = [
  { id: 0, value: undefined, label: "Selecione seu Estado" },
  { id: 1, value: "AC", label: "AC" },
  { id: 2, value: "AL", label: "AL" },
  { id: 3, value: "AP", label: "AP" },
  { id: 4, value: "AM", label: "AM" },
  { id: 5, value: "BA", label: "BA" },
  { id: 6, value: "CE", label: "CE" },
  { id: 7, value: "DF", label: "DF" },
  { id: 8, value: "ES", label: "ES" },
  { id: 9, value: "GO", label: "GO" },
  { id: 10, value: "MA", label: "MA" },
  { id: 11, value: "MT", label: "MT" },
  { id: 12, value: "MS", label: "MS" },
  { id: 13, value: "MG", label: "MG" },
  { id: 14, value: "PA", label: "PA" },
  { id: 15, value: "PB", label: "PB" },
  { id: 16, value: "PR", label: "PR" },
  { id: 17, value: "PE", label: "PE" },
  { id: 18, value: "PI", label: "PI" },
  { id: 19, value: "RJ", label: "RJ" },
  { id: 20, value: "RN", label: "RN" },
  { id: 21, value: "RS", label: "RS" },
  { id: 22, value: "RO", label: "RO" },
  { id: 23, value: "RR", label: "RR" },
  { id: 24, value: "SC", label: "SC" },
  { id: 25, value: "SP", label: "SP" },
  { id: 26, value: "SE", label: "SE" },
  { id: 27, value: "TO", label: "TO" },
];

export const genderSelect = [
  { id: 0, value: undefined, label: "Selecione seu gênero" },
  { id: 1, value: "F", label: "Feminino" },
  { id: 2, value: "M", label: "Masculino" },
  { id: 3, value: "O", label: "Outros" },
  { id: 2, value: "N", label: "Prefiro não informar" },
];

export const phoneTypeSelect = [
  // { id: 0, value: undefined, label: "Tipo de telefone" },
  { id: 1, value: "1", label: "Residencial" },
  { id: 2, value: "2", label: "Comercial" },
  { id: 3, value: "3", label: "Celular" },
];

export const storeSelect = [
  { id: 0, value: undefined, label: "Lojas participantes" },
  { id: 1, value: "americanas", label: "Americanas" },
  { id: 2, value: "atacadao", label: "Atacadao" },
  { id: 3, value: "condor", label: "Condor" },
  { id: 4, value: "pao-de-acucar", label: "Pão de Açucar" },
  { id: 5, value: "super-pague-menos", label: "Super Pague Menos" },
  { id: 6, value: "savegnago", label: "Savegnago" },
  { id: 7, value: "soneda", label: "Soneda" },
  { id: 8, value: "rissul", label: "Rissul" },
  { id: 9, value: "tauste", label: "Tauste" },
  { id: 10, value: "proenca", label: "Proenca" },
  { id: 11, value: "macromix-atacado", label: "Macromix Atacado" },
  { id: 12, value: "tenda-atacado", label: "Tenda Atacado" },
  { id: 13, value: "lojas-rede", label: "Lojas Rede" },
  { id: 14, value: "angeloni", label: "Angeloni" },
  { id: 15, value: "ofertas-mateus", label: "Ofertas Mateus" },
  { id: 16, value: "sonda-delivery", label: "Sonda Delivery" },
  { id: 17, value: "mercadinhos-sao-luiz", label: "Mercadinhos Sao Luiz" },
  { id: 18, value: "costa-atacadao", label: "Costa Atacadao" },
  { id: 19, value: "drogaraia", label: "Drogaraia" },
  { id: 20, value: "pague-menos", label: "Pague Menos" },
  { id: 21, value: "drogasil", label: "Drogasil" },
  { id: 22, value: "mercado-livre", label: "Mercado Livre" },
];
